<template>
	<svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 341.41 277.51">
		<defs></defs>
		<polygon class="cls-1" points="148.7 105.1 85.9 105.1 85.9 107.7 84.6 112 75.1 158.9 75.8 208.4 296.8 206.2 294.6 201 251.3 107.5 148.7 105.1" />
		<path class="cls-2" d="M297.7,123.8c3,16.7,4.1,24.7,4.1,24.7l-52.5-72-9.8-47.2,47.3,52S294.7,107.1,297.7,123.8Z" />
		<path
			class="cls-3"
			d="M283.6,50.8V78.7l2.6.3,19,79.1.3,119.1,34.9.3s1.1.2,1-1.3-4-223.5-4-223.5c0-.9.2-1.9-1.4-1.9Zm3.8,26.3a6.09,6.09,0,0,0-1.9.3l.3-23.8h49.4l4.1,222H306.71V158.4s-18.3-79.1-18.4-79.8,0-1.4-.9-1.5Z"
		/>
		<polygon class="cls-3" points="337.1 51.1 257.7 0 221.6 0 257.7 0.7 334.8 50.9 337.1 51.1" />
		<path class="cls-3" d="M283.7,52.4,221.6,0l62.9,51.1Z" />
		<polygon class="cls-3" points="283.7 76 223.9 13.3 221.6 0 223.9 13.3 283.7 78.7 283.7 76" />
		<polygon class="cls-3" points="248 97.3 244 52.4 246.8 97.8 300.7 206.2 248 97.3" />
		<path class="cls-3" d="M191.1,277.3c-18.3-.1-115.2,0-115.2,0l.8-.7s65.9-.6,114.2-.6,114.6,1.3,114.6,1.3S209.4,277.4,191.1,277.3Z" />
		<polygon class="cls-3" points="305.7 218.1 182.9 218.6 75.9 218.6 75.9 216.6 182.9 216.6 305.7 216.6 305.7 218.1" />
		<polygon class="cls-3" points="75.8 208.4 74.4 213.3 203.5 212.6 302.7 212.6 302.7 208.9 75.8 208.4" />
		<path class="cls-3" d="M303.1,208.6H75.9l226.8.8v3.1H75.7V214l228-.5v-4.2a.65.65,0,0,0-.6-.7Z" />
		<path
			class="cls-3"
			d="M39.41,59.5C39.41,62.9,42,275.1,42,276s.2,1.3,2.1,1.3H75.8c.6,0,1-.7.9-1.8S75,159,75,159,90.2,84.5,90.5,82.4s2-1.6,3.1-2.2,1-3.8,1-3.8c0-1.5-1.4-20-1.4-21s-.8-1.9-2.6-1.9-45,1.6-47.8,1.6S39.41,56.1,39.41,59.5Zm2.4-1a1.2,1.2,0,0,1,1.2-1c.7,0,48-1.7,48-1.7s1.5,19.6,1.5,20.9A1.92,1.92,0,0,1,91,78.6c-.8.2-1.9.1-2.3,1.8s-14,70.9-14.6,73.7a29.77,29.77,0,0,0-1.1,6.7c0,1.6,1.5,113,1.5,113,0,.7-.2,1.3-1.1,1.3H45.71c-1.4,0-1.3-1-1.3-1.7S41.8,59.1,41.81,58.5Z"
		/>
		<polygon class="cls-3" points="91.3 53.5 37.5 1.9 1.1 2.5 37.5 1.9 93 54.4 91.3 53.5" />
		<polygon class="cls-3" points="40.2 56 1.1 2.5 41.8 55.2 40.2 56" />
		<polygon class="cls-3" points="211.3 111.6 84.6 112 247 110.7 291 201 245.7 111.8 211.3 111.6" />
		<polygon class="cls-2" points="254.5 128.9 243.3 202.2 291 201 254.5 128.9" />
		<path class="cls-2" d="M79.9,135.1c-1.8,8.7-3.2,13.6-4.8,23.8,0,0,.8,25.2.8,41.1l43.2.6C107.2,179.4,91.8,156.3,79.9,135.1Z" />
		<path class="cls-3" d="M188.5,203.1c-35.2.2-102.6-1.8-102.6-1.8s71.9-1.2,102.8-1.3S291,201.3,291,201.3,223.7,202.9,188.5,203.1Z" />
		<polygon class="cls-3" points="212.5 106.7 212.4 107.3 251.3 107.5 212.5 106.7" />
		<polygon class="cls-3" points="212.4 107.3 85.9 107.7 212.5 106.6 212.4 107.3" />
		<polygon class="cls-3" points="299 144.8 249.7 78.7 238.4 29.1 286 84.3 238.4 29.1 251.3 77.4 298.5 143.2 292.4 106.5 299 144.8" />
		<polygon class="cls-3" points="2 178.1 1.1 2.5 0 177.2 43 275.7 2 178.1" />
		<rect class="cls-4" x="170.7" y="82.4" width="38" height="101.5" />
		<polygon class="cls-4" points="131.9 49.4 170.71 82.4 170.71 183.9 131.9 125.5 131.9 49.4" />
		<polygon class="cls-4" points="170.7 82.4 208.7 82.4 163.49 49.4 131.9 49.4 170.7 82.4" />
		<path
			class="cls-5"
			d="M137.8,89.66a2.16,2.16,0,0,1,2.12-1.08,2.72,2.72,0,0,1,2.23,1.34,3.74,3.74,0,0,1,1,2.5,6.73,6.73,0,0,1-.75,2.94,2.64,2.64,0,0,1-2.32,1.48c-.85.14-1.69-.42-2.31-1.55a5.63,5.63,0,0,1-.65-3A5.82,5.82,0,0,1,137.8,89.66Z"
		/>
		<path
			class="cls-5"
			d="M135.86,99.15a1.81,1.81,0,0,1,1.42-1,1.61,1.61,0,0,1,1.55.6,2.11,2.11,0,0,1,.76,1.53,4.76,4.76,0,0,1-.4,2,2.19,2.19,0,0,1-1.56,1.31,1.42,1.42,0,0,1-1.61-.73,3.08,3.08,0,0,1-.55-1.89A4.1,4.1,0,0,1,135.86,99.15Z"
		/>
		<path
			class="cls-5"
			d="M135.23,105.91a1.46,1.46,0,0,1,1-.79,1.22,1.22,0,0,1,1.14.24,1.34,1.34,0,0,1,.64.92,3,3,0,0,1-.16,1.35,1.67,1.67,0,0,1-1,1,1.05,1.05,0,0,1-1.21-.3,1.81,1.81,0,0,1-.51-1.18A2.39,2.39,0,0,1,135.23,105.91Z"
		/>
		<path
			class="cls-5"
			d="M134.77,112a1.5,1.5,0,0,1,.87-.84,1.15,1.15,0,0,1,1.11,0,1.11,1.11,0,0,1,.65.74,2.52,2.52,0,0,1-.09,1.26,1.64,1.64,0,0,1-.92,1,1,1,0,0,1-1.17-.11,1.61,1.61,0,0,1-.52-1A2.18,2.18,0,0,1,134.77,112Z"
		/>
		<path
			class="cls-5"
			d="M135.65,117.2a1.28,1.28,0,0,1,.59-.7.85.85,0,0,1,.77-.08.6.6,0,0,1,.47.46,1.82,1.82,0,0,1,0,.9,1.41,1.41,0,0,1-.61.85.66.66,0,0,1-.82,0,1,1,0,0,1-.39-.66A1.54,1.54,0,0,1,135.65,117.2Z"
		/>
		<path
			class="cls-5"
			d="M138.68,118.12a8.23,8.23,0,0,1-.63-2.25,32.54,32.54,0,0,1,.46-6.94,62.09,62.09,0,0,1,3.69-11.5c.58-1.48,1.71-3.88,3.27-4.58,1.22-.73,2.55,0,3.41,1.81a14.39,14.39,0,0,1,.88,5.54c.1,1.56.24,3.1.43,4.62a12.25,12.25,0,0,0,2,5.4,1.93,1.93,0,0,0,2.23.74,6,6,0,0,0,2.19-1.1,15.14,15.14,0,0,1,3.33-1.4,5.75,5.75,0,0,1,4.37.82,7.92,7.92,0,0,1,2.66,2.56,5.48,5.48,0,0,1,.9,2.36,9.88,9.88,0,0,1,0,2.43,14.53,14.53,0,0,1-.58,2.69,13.65,13.65,0,0,1-1.64,3.56c-1.23,1.87-2.75,2.87-4.31,2.85a5.48,5.48,0,0,1-3.06-.69,6.61,6.61,0,0,1-1.81-1.37c-2.43-2.26-4.38-2.18-6.79-2.81a27.12,27.12,0,0,0-3.36-.82,35.52,35.52,0,0,0-3.85.06,4.4,4.4,0,0,1-2.08-.27A3.5,3.5,0,0,1,138.68,118.12Z"
		/>
	</svg>
</template>

<script>
	export default {
		name: 'FoamBoxLeftSVG'
	};
</script>
<style scoped>
	.cls-1 {
		fill: #d9dce1;
	}
	.cls-2 {
		fill: #d3d3d3;
	}
	.cls-3 {
		fill: #707070;
	}
	.cls-4 {
		fill: #96b5cc;
		stroke: #000;
		stroke-linejoin: round;
		stroke-width: 0.75px;
	}
	.cls-5 {
		fill: #fff;
		stroke: #707070;
		stroke-width: 0.5px;
	}
</style>
